module.exports = __webpack_public_path__ + "img/photo-0122.989ce09e.jpg";